import { useState } from "react";
import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Image3 from "./img/webp/1Plafond tendu circulaire avec éclairage LED intégré, design architectural moderne pour espace professionnel – UNIK SYSTEM.webp"
import Image25 from "./img/webp/2Plafond lumineux architectural en bois avec éclairage LED intégré dans un salon VIP de stade – Solutions UNIK SYSTEM.webp"
// import Image1 from "./img/webp/3Plafond décoratif suspendu avec éclairage LED ciel rétroéclairé, design innovant pour espace commercial – UNIK SYSTEM.webp"
import Image4 from "./img/webp/4Plafond tendu lumineux imprimé ciel et feuillage avec rétroéclairage LED, solution décorative et technique – UNIK SYSTEM.webp"
import Image5 from "./img/webp/6Plafond tendu étoilé LED bleu créant une ambiance décorative moderne et immersive.webp"
import Image6 from "./img/webp/7Plafond tendu noir avec éclairage LED effet ciel étoilé dans un intérieur contemporain.webp"
import Image7 from "./img/webp/8Installation de plafond technique avec panneaux lumineux LED encastrés en cours de chantier.webp"
import Image8 from "./img/webp/9Plafond décoratif avec lignes LED intégrées offrant un éclairage architectural moderne.webp"
import Image9 from "./img/webp/10Plafond lumineux rétroéclairé avec toile tendue et logo institutionnel intégré.webp"
// import Image10 from "./img/webp/11Plafond architectural LED à motif géométrique pour hall et espace de prestige.webp"
import Image11 from "./img/webp/12Plafond tendu lumineux continu installé dans un espace professionnel moderne.webp"
import Image12 from "./img/webp/13Façade architecturale moderne de la gare Rabat Agdal avec habillage et éclairage intégré.webp"
import Image13 from "./img/webp/15Plafond tendu étoilé LED au-dessus d’une piscine intérieure pour une ambiance premium.webp"
import Image14 from "./img/webp/16Plafond tendu lumineux LED circulaire pour salle professionnelle – solution lighting UNIK SYSTEM.webp"
// import Image15 from "./img/webp/17Plafond lumineux design sur mesure avec éclairage LED intégré – UNIK SYSTEM Lighting Solution.webp"
// import Image16 from "./img/webp/18Éclairage LED géométrique moderne pour couloir et bureau – UNIK SYSTEM lighting architectural.webp"
// import Image17 from "./img/webp/19Plafond tendu lumineux dans une cuisine moderne avec éclairage LED intégré – installation professionnelle Unik System.webp"
// import Image18 from "./img/webp/20Plafond tendu lumineux XXL en forme de caisson carré dans un salon contemporain, éclairage diffus LED.webp"
// import Image30 from "./img/webp/21Éclairage LED décoratif pour spa et espace bien-être – lighting solution UNIK SYSTEM.webp"
import Image20 from "./img/webp/22Mur lumineux architectural avec lignes LED intégrées – solution lighting UNIK SYSTEM.webp"
// import Image21 from "./img/webp/23Plafond LED design pour salle de conférence moderne – éclairage professionnel UNIK SYSTEM.webp"
// import Image22 from "./img/webp/24Éclairage LED créatif et décoratif pour espace commercial – UNIK SYSTEM lighting.webp"
import Image23 from "./img/webp/25Solution lighting sur mesure avec LED intégrée pour architecture intérieure – UNIK SYSTEM.webp"
import Image2 from "./img/webp/26Plafond tendu lumineux circulaire avec éclairage LED RGB installé par UNIK SYSTEM dans un bowling moderne_imgupscaler..webp"
import Image24 from "./img/webp/27Installation de plafond tendu lumineux avec lignes LED intégrées par UNIK SYSTEM, solution d’éclairage architectural moderne.webp"
import Image26 from "./img/webp/28Plafond tendu lumineux design aux formes organiques réalisé par UNIK SYSTEM pour un espace professionnel.webp"
import Image27 from "./img/webp/29Éclairage architectural avec anneaux LED intégrés au plafond, solution lighting UNIK SYSTEM pour salle de réunion.webp"
import Image28 from "./img/webp/30Plafonds suspendus lumineux LED design installés par UNIK SYSTEM dans un open space contemporain.webp"
// import Image29 from "./img/webp/31Plafonds suspendus lumineux LED design installés par UNIK SYSTEM dans un open space contemporain.webp"
import Image19 from "./img/webp/34Plafond architectural moderne.webp"






const images = [
  // { id: 1, src: Image1 ,title: "Solutions lumineuses architecturales suspendues au plafond"},
  { id: 2, src: Image2 ,title: "Plafond lumineux circulaire pour espace bowling"},
  { id: 3, src: Image3 ,title: "Plafond circulaire lumineux intégré Fédération royale marocaine de football"},
  { id: 4, src: Image4 ,title: "Plafond étoilé LED créant une ambiance immersive et élégante"},
  { id: 5, src: Image5 ,title: "Plafond étoilé à fibres optiques pour une ambiance nocturne apaisante"},
  { id: 6, src: Image6 ,title: "Plafond lumineux imprimé ciel et nature pour ambiance apaisante"},
  { id: 7, src: Image7 ,title: "Installation de plafond avec des caissons lumineux LED encastrés"},
  { id: 8, src: Image8 ,title: "Plafond à lignes LED intégrées pour éclairage architectural moderne"},
  { id: 9, src: Image9 ,title: "Plafond lumineux rétroéclairé avec toile tendue et logo institutionnel intégré"},
  // { id: 10, src: Image10 ,title: "Plafond architectural LED à motif géométrique pour hall et espace de prestige"},
  { id: 11, src: Image11 ,title: "Plafond lumineux diffus intégré pour éclairage uniforme d’espace professionnel"},
  { id: 12, src: Image12 ,title: "Façade architecturale moderne de la gare Rabat Agdal"},
  { id: 13, src: Image13 ,title: "Plafond étoilé lumineux avec LED d’ambiance pour piscine intérieure premium"},
  { id: 14, src: Image14 ,title: "Plafond tendu lumineux LED circulaire pour salle professionnelle"},
  // { id: 15, src: Image15 ,title: "alle de réunion contemporaine avec plafond lumineux sculptural"},
  // { id: 16, src: Image16 ,title: "Couloir moderne avec plafond lumineux géométrique et effet miroir"},
  // { id: 17, src: Image17 ,title: "Cuisine contemporaine avec plafond miroir et éclairage central design"},
  // { id: 18, src: Image18 ,title: "Salon moderne avec des caissons lumineux LED encastré et ambiance élégante"},
  { id: 19, src: Image19 ,title: "Plafond architectural sculptural avec éclairage LED intégré Grand théâtre de Rabat"},
  { id: 20, src: Image20 ,title: "Galerie murale contemporaine avec des caissons lumineux LED"},
  // { id: 21, src: Image21 ,title: "Mur architectural contemporain à éclairage LED graphique intégré"},
  // { id: 22, src: Image22 ,title: "Salle de conférence moderne avec éclairage LED géométrique au plafond"},
  { id: 23, src: Image23 ,title: "Sauna moderne en bois avec éclairage LED intégré"},
  { id: 24, src: Image24 ,title: "Plafond lumineux design à lignes LED intégrées, en cours d’installation"},
  { id: 25, src: Image25 ,title: "Salon VIP de stade éclairage circulaire intégré"},
  { id: 26, src: Image26 ,title: "Plafond lumineux tendu en cours d’installation"},
  { id: 27, src: Image27 ,title: "Plafond design à anneaux LED concentriques dans une salle de réunion"},
  { id: 28, src: Image28 ,title: "Plafond suspendu avec îlots lumineux LED intégrés"},
  // { id: 29, src: Image29 ,title: "Plafond suspendu avec îlots lumineux LED intégrés"},
  // { id: 30, src: Image30 ,title: "Plafond design à rubans LED courbes – Éclairage architectural immersif"},
];
const Gallery = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  

  return (
    <>
      {/* ===== Title ===== */}
      <div className="container titre-gallry projects-header" id="titre-gallry">
        <h2 data-aos="fade-up" className="section-titles">
          Nos Réalisations – Projets & Installations Professionnelles
        </h2>
        <p data-aos="fade-up">
          Découvrez nos projets réalisés avec expertise et précision.
        </p>
      </div>

      {/* ===== Gallery ===== */}
      <div className="simple-gallery">
        {images.map((img) => (
          <div data-aos="zoom-in" key={img.id} className="gallery-item">
            <img src={img.src} alt={img.title} />

            {/* ✅ Zoom button */}
            <button
              className="zoom-icon"
              onClick={() => setActiveItem(img)}
              aria-label="Zoom image"
              loading="lazy"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* ===== Lightbox ===== */}
      {activeItem && (
        <div className="lightbox" onClick={() => setActiveItem(null)}>
          <div className="content" onClick={(e) => e.stopPropagation()}>
            <img src={activeItem.src} alt={activeItem.title} loading="lazy"/>
            
            {/* ✅ TITLE */}
            <div className="image-title">
              {activeItem.title}
            </div>

            <button
              className="close"
              onClick={() => setActiveItem(null)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
